export const userLink = $axios => ({
  get: (viewId, { fieldId, recordId }) => $axios.$get(`/views/${viewId}/fields/${fieldId}/links/user_link`, {
    params: { record_id: recordId },
  }),
});
